(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/video-player-controller.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/video-player-controller.js');

'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
var _svs$components$error = svs.components.errorBoundary,
  ErrorBoundary = _svs$components$error.ErrorBoundary,
  GenericError = _svs$components$error.GenericError;
var _svs$components$redbe = svs.components.redbee_video_player,
  Button = _svs$components$redbe.Button,
  ControllerButtons = _svs$components$redbe.ControllerButtons,
  LiveButton = _svs$components$redbe.LiveButton,
  PlayerEvents = _svs$components$redbe.PlayerEvents,
  ProgressBar = _svs$components$redbe.ProgressBar,
  Volume = _svs$components$redbe.Volume;
var _svs$components$redbe2 = svs.components.redbee_video_player.Utils,
  secondsDate = _svs$components$redbe2.secondsDate,
  volumeStrengthIndicator = _svs$components$redbe2.volumeStrengthIndicator,
  secondsToHms = _svs$components$redbe2.secondsToHms,
  removeEmptyTime = _svs$components$redbe2.removeEmptyTime,
  displayTime = _svs$components$redbe2.displayTime;
var VideoPlayerController = function VideoPlayerController(_ref) {
  var footerButton = _ref.footerButton,
    headerButton = _ref.headerButton,
    headerInfo = _ref.headerInfo,
    remountPlayer = _ref.remountPlayer,
    player = _ref.player,
    replay = _ref.replay;
  var progressBarRef = useRef(null);
  var volumeSliderRef = useRef(null);
  var volumeSliderContainerRef = useRef(null);
  var seekTimerRef = useRef(null);
  var currentSeekPositionRef = useRef(null);
  var _useState = useState(100),
    _useState2 = _slicedToArray(_useState, 2),
    currentSeek = _useState2[0],
    setCurrentSeek = _useState2[1];
  var _useState3 = useState('0:00'),
    _useState4 = _slicedToArray(_useState3, 2),
    currentTime = _useState4[0],
    setCurrentTime = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    currentTimePosition = _useState6[0],
    setCurrentTimePosition = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    seekTimer = _useState8[0],
    setSeekTimer = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    seekTimerPosition = _useState10[0],
    setSeekTimerPosition = _useState10[1];
  var _useState11 = useState('0:00'),
    _useState12 = _slicedToArray(_useState11, 2),
    duration = _useState12[0],
    setDuration = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    displayClass = _useState14[0],
    setDisplayClass = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isLiveEdge = _useState16[0],
    setIsLiveEdge = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isPlaying = _useState18[0],
    setIsPlaying = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isFullscreen = _useState20[0],
    setIsFullscreen = _useState20[1];
  var _useState21 = useState(100),
    _useState22 = _slicedToArray(_useState21, 2),
    volume = _useState22[0],
    setVolume = _useState22[1];
  var _useState23 = useState(100),
    _useState24 = _slicedToArray(_useState23, 2),
    previousVolume = _useState24[0],
    setPreviousVolume = _useState24[1];

  var isSafari = svs.core.detect.browser.safari();

  var isLive = function isLive() {
    return player.isLive();
  };
  var isPictureInPictureSupported = function isPictureInPictureSupported() {
    return player.isPictureInPictureSupported();
  };
  var play = function play() {
    player.play();
  };
  var hasNotEnded = function hasNotEnded() {
    return player.getState().playbackState !== 'ended';
  };
  var playerSetVolume = function playerSetVolume(value) {
    return player.setVolume({
      percentage: value
    });
  };
  var pause = function pause() {
    player.pause();
  };
  var seekTo = function seekTo(change) {
    return player.seekTo(change);
  };
  var seekToUTC = function seekToUTC(ms) {
    return player.seekToUTC(ms);
  };
  var setMuted = function setMuted(bool) {
    return player.setMuted(bool);
  };
  var toggleFullscreen = function toggleFullscreen() {
    return player.toggleFullscreen();
  };
  var togglePictureInPicture = function togglePictureInPicture() {
    return player.togglePictureInPicture();
  };
  var isVOD = function isVOD() {
    return !player.isLive();
  };
  var seekToLive = function seekToLive() {
    return player.seekToLive();
  };
  var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
  useEffect(function () {
    if (isVOD()) {
      setCurrentSeek(0);
    }
    var eventHandlerSetup = function eventHandlerSetup(event, data) {
      var _document, _document2, _document3, _document4;
      if (event === PlayerEvents.TIME_UPDATE || event === PlayerEvents.SEEKING) {
        var newDuration = secondsToHms(playerDuration(data));
        if (duration !== newDuration) {
          setDuration(newDuration);
        }
        var _currentTime = secondsToHms(isVOD() ? data.currentTime : secondsDate(data.utcCurrentTime - data.utcSeekable.start));
        setCurrentTime(_currentTime);
        if (isVOD()) {
          setCurrentSeek(data.currentTime / data.duration * 100);
        } else {
          setCurrentSeek((data.currentTime - data.seekable.start) / (data.duration - data.seekable.start) * 100);
        }
      }
      switch (data === null || data === void 0 ? void 0 : data.playbackState) {
        case 'playing':
          setIsPlaying(true);
          break;
        case 'paused':
          setIsPlaying(false);
          break;
        case 'ended':
          setIsPlaying(false);
          if (fullscreenElement) {
            setIsFullscreen(false);
          }
          if (fullscreenElement && (_document = document) !== null && _document !== void 0 && _document.exitFullscreen) {
            document.exitFullscreen();
          } else if (fullscreenElement && (_document2 = document) !== null && _document2 !== void 0 && _document2.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (fullscreenElement && (_document3 = document) !== null && _document3 !== void 0 && _document3.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (fullscreenElement && (_document4 = document) !== null && _document4 !== void 0 && _document4.msExitFullscreen) {
            document.msExitFullscreen();
          }
          break;
        default:
          break;
      }
      if (player.getState().isAtLiveEdge) {
        setIsLiveEdge(true);
      } else {
        setIsLiveEdge(false);
      }
    };
    if (isFullscreen === false && player.getState().playbackState !== 'ended' && fullscreenElement) {
      setIsFullscreen(true);
    }
    if (isFullscreen === true && !fullscreenElement) {
      setIsFullscreen(false);
    }

    player.onAll(function (_ref2) {
      var event = _ref2.event,
        data = _ref2.data;
      eventHandlerSetup(event, data);
    });
    return function () {
      player.removeEventListener(PlayerEvents.ALL, eventHandlerSetup);
    };
  }, [, footerButton, headerButton, headerInfo, player, fullscreenElement]);
  useEffect(function () {
    if (player.getState('ended') && replay) {
      player.destroy();
      remountPlayer();
    }
  }, [replay]);

  var playerDuration = function playerDuration(data) {
    if (isLive()) {
      var _data$utcSeekable;
      var seconds = secondsDate((data === null || data === void 0 ? void 0 : data.utcDuration) - (data === null || data === void 0 || (_data$utcSeekable = data.utcSeekable) === null || _data$utcSeekable === void 0 ? void 0 : _data$utcSeekable.start));
      return seconds;
    }
    return data === null || data === void 0 ? void 0 : data.duration;
  };

  var toggleVolume = function toggleVolume(volumeToggle) {
    setDisplayClass(true);
    if (volumeToggle) {
      setMuted(previousVolume === 0);
      setVolume(previousVolume);
    } else {
      setMuted(true);
      setVolume(0);
    }
  };

  var setVolumePercentage = function setVolumePercentage(percentage) {
    var roundedPercentage = Math.round(percentage);
    setDisplayClass(true);
    playerSetVolume(roundedPercentage);
    setPreviousVolume(roundedPercentage);
    setVolume(roundedPercentage);
    setMuted(roundedPercentage === 0);
  };

  var calculateNewTime = function calculateNewTime(percentagePosition) {
    var duration = player.getState().duration;
    var change = duration * percentagePosition;
    var newTimeInMS = dateFns.add(new Date(player.getState().seekable.start), {
      seconds: change
    }).getTime();
    return newTimeInMS;
  };

  var seekToPosition = function seekToPosition(percentagePosition, x) {
    var _currentSeekPositionR;
    var newTimeInMS;
    if (isLive()) {
      var _duration = player.getState().utcSeekable.end - player.getState().utcSeekable.start;
      var change = secondsDate(_duration * percentagePosition);
      newTimeInMS = dateFns.add(new Date(player.getState().utcSeekable.start), {
        seconds: change
      }).getTime();
      seekToUTC(newTimeInMS);
    } else {
      newTimeInMS = calculateNewTime(percentagePosition);
      seekTo({
        time: newTimeInMS / 1000
      });
    }
    var width = parseInt(currentSeekPositionRef === null || currentSeekPositionRef === void 0 || (_currentSeekPositionR = currentSeekPositionRef.current) === null || _currentSeekPositionR === void 0 ? void 0 : _currentSeekPositionR.clientWidth, 10) || 0;
    setCurrentTimePosition(x - width / 2);
  };

  var setSeekTime = function setSeekTime(percentagePosition, x) {
    var _seekTimerRef$current;
    var newTimeInMS;
    var newTimeInSeconds;
    if (isLive()) {
      var start = new Date(player.getState().utcSeekable.start).getTime();
      var end = new Date(player.getState().utcSeekable.end).getTime();
      var diffInSeconds = (end - start) / 1000 * percentagePosition;
      var newDate = dateFns.add(new Date(start), {
        seconds: diffInSeconds
      });
      var diff = dateFns.intervalToDuration({
        start: newDate,
        end: end
      });
      newTimeInSeconds = "-".concat(removeEmptyTime(displayTime(String(diff.hours)))).concat(displayTime(diff.minutes)).concat(displayTime(diff.seconds, true));
    } else {
      newTimeInMS = calculateNewTime(percentagePosition);
      newTimeInSeconds = secondsToHms(newTimeInMS / 1000);
    }
    var width = parseInt(seekTimerRef === null || seekTimerRef === void 0 || (_seekTimerRef$current = seekTimerRef.current) === null || _seekTimerRef$current === void 0 ? void 0 : _seekTimerRef$current.clientWidth, 10) || 0;
    setSeekTimerPosition(x - width / 2);
    setSeekTimer(newTimeInSeconds);
  };
  var mousestart = function mousestart() {
    hasNotEnded() && setDisplayClass(true);
  };
  var mouseout = function mouseout() {
    setDisplayClass(false);
  };
  var touchstart = function touchstart(evt) {
    if (evt.target.className !== 'vjs-modal-dialog streamplayer-overlay') {
      return;
    }
    if (displayClass) {
      setDisplayClass(false);
    } else {
      setDisplayClass(true);
    }
  };
  var touchend = function touchend(evt) {
    if (evt.target.className !== 'vjs-modal-dialog streamplayer-overlay') {
      return;
    }
    evt.preventDefault();
  };
  useEffect(function () {
    var timeout = setTimeout(function () {
      setDisplayClass(false);
    }, 3000);
    return function () {
      clearTimeout(timeout);
    };
  }, [displayClass]);
  return React.createElement("div", {
    className: "video-player-controller ".concat(displayClass ? 'video-player-controller-display' : 'vjs-user-inactive', " ").concat(isFullscreen && 'vjs-fullscreen'),
    onMouseLeave: mouseout,
    onMouseMove: mousestart,
    onMouseOver: mousestart,
    onTouchEnd: touchend,
    onTouchStart: touchstart
  }, React.createElement(ErrorBoundary, {
    renderOnError: GenericError
  }, React.createElement("div", {
    className: "vjs-modal-dialog streamplayer-overlay"
  }), React.createElement("div", {
    className: "vjs-control-bar"
  }, isLive() && React.createElement(LiveButton, {
    isLiveEdge: isLiveEdge,
    seekToLive: seekToLive
  }), React.createElement(Volume, {
    hasSlider: !isSafari,
    setVolumePercentage: setVolumePercentage,
    toggleVolume: toggleVolume,
    volume: volume,
    volumeSliderContainerRef: volumeSliderContainerRef,
    volumeSliderRef: volumeSliderRef,
    volumeStrengthIndicator: volumeStrengthIndicator
  }), React.createElement(ProgressBar, {
    currentSeek: currentSeek,
    currentSeekPositionRef: currentSeekPositionRef,
    currentTime: currentTime,
    currentTimePosition: currentTimePosition,
    duration: duration,
    isVOD: isVOD,
    progressBarRef: progressBarRef,
    seekTimer: seekTimer,
    seekTimerPosition: seekTimerPosition,
    seekTimerRef: seekTimerRef,
    seekToPosition: seekToPosition,
    setSeekTime: setSeekTime
  }), footerButton && React.createElement(Button, {
    classes: "icon vjs-control vjs-button vjs-footer-button",
    iconClasses: footerButton.icon,
    onClick: function onClick() {
      return footerButton.customOnClick();
    }
  }), isPictureInPictureSupported() && React.createElement(Button, {
    classes: "vjs-pip-control vjs-control vjs-button icon",
    iconClasses: "icon-picture-in-picture",
    onClick: togglePictureInPicture,
    title: "Picture in picture"
  }), React.createElement(Button, {
    classes: "vjs-fullscreen-control vjs-control vjs-button icon",
    iconClasses: "icon-maximize",
    onClick: toggleFullscreen,
    title: "Fullsk\xE4rm"
  })), React.createElement(ControllerButtons, {
    headerButton: headerButton,
    headerInfo: headerInfo,
    isPlaying: isPlaying,
    isVOD: isVOD,
    pause: pause,
    play: play,
    player: player,
    seekTo: seekTo
  })));
};
svs.components.redbee_video_player.VideoPlayerController = VideoPlayerController;

 })(window);